import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { Container } from '@/components/ui/Container';
import { Photo } from '@/components/ui/Photo';
import { type ImageKey } from '@/data/images';
import { useImages } from '@/lib/images';
import { useReveal } from '@/lib/useReveal';
import { PageHeader } from '@/components/ui/PageHeader';

const TILES: { key: ImageKey; label: string; tall?: boolean }[] = [
  { key: 'lounge', label: 'The relaxation lounge', tall: true },
  { key: 'oils', label: 'Aromatherapy oils' },
  { key: 'facial', label: 'Glow facials' },
  { key: 'stones', label: 'Hot stone ritual', tall: true },
  { key: 'nails', label: 'Nail bar' },
  { key: 'massage', label: 'Quiet corners' },
];

export function Gallery() {
  useReveal();
  const img = useImages();
  return (
    <>
      <Seo title="Gallery" description="A look inside Grace Haven Spa — calm treatment rooms, the relaxation lounge, and the details that set the mood." />

      <PageHeader eyebrow="A look inside" title="Gallery" />

      <section className="bg-cream py-24">
        <Container>
          <div className="grid auto-rows-[220px] grid-cols-2 gap-4 lg:grid-cols-3">
            {TILES.map((t) => (
              <div key={t.label} className={`reveal group relative overflow-hidden rounded-sm border border-line ${t.tall ? 'row-span-2' : ''}`}>
                <Photo src={img[t.key]} alt={t.label} className="h-full w-full" imgClassName="transition duration-700 group-hover:scale-105" />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-espresso-deep/70 via-transparent to-transparent" />
                <p className="pointer-events-none absolute bottom-0 left-0 p-5 font-display text-xl text-cream">{t.label}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-center font-body text-xs uppercase tracking-wide text-muted">Stock imagery — your own photos drop straight in</p>

          <div className="mt-14 text-center">
            <Link to="/booking" className="btn-primary">Book your visit</Link>
          </div>
        </Container>
      </section>
    </>
  );
}
